var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmoji = function SvgEmoji(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 12,
    fill: "#E7E7E7",
    stroke: "#E7E7E7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 21.571,
    r: 1.714,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.857,
    cy: 21.571,
    r: 1.714,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M18.143 27.571c0 2.84 3.07 5.143 6.857 5.143 3.787 0 6.857-2.302 6.857-5.143"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmoji);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/emoji.85ad4b990b6fdc02a8c996f1462b1172.svg";